export default function policiesSingleReducer(
    state: any = {
        loading: false,
        done: false,
        error: null,
        response: {
            'clientName': '',
            'inceptionDate': '',
            'expiryDate': '',
            'policyTypeId': 1,
            'policyNumber': '',
            'premium': 0,
            'commission': 0,
            'excess': 0,
            'settlementBasis': 1.5,
            'priceBasis': '',
            'totalSumInsured': 0,
            'operativeSections': [],
        },
    },
    action: any) {

    switch (action.type) {

        /**
         *     Get existing locations
         */
        case 'GET_POLICY_SINGLE_PENDING': {
            return { ...state, loading: true }
        }

        case 'GET_POLICY_SINGLE_REJECTED': {
            return { ...state, loading: false, error: action.payload }
        }

        case 'GET_POLICY_SINGLE_FULFILLED': {
            return {
                ...state, loading: false, done: true, error: null, response: action.payload.policy,
            }
        }

        /**
         *     Default
         */
        default: {
            return { ...state }
        }

    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/reducers/policies/view.ts